import { Provider } from '@/modules/provider/entities/interfaces/provider';
import { generateMockBase } from '@/utils/tests/createEntity';

export const MOCK_PROVIDER: Provider = {
  id: 'f7c43a7f-88fc-4177-a62a-f340eae3047d',
  createdAt: '2023-05-01T12:00:00Z',
  updatedAt: '2023-05-02T10:30:00Z',
  deletedAt: null,
  deletionReason: null,
  name: 'Mock Provider',
  cnpj: '1234567890',
};

export const generateMockProvider = (override?: Partial<Provider>): Provider => ({
  ...generateMockBase(),
  name: 'Mock Provider',
  cnpj: '1234567890',
  ...override,
});
